{
  "navigation": {
    "menu": "Menú",
    "primary": "Navegación principal",
    "account": "Cuenta"
  },
  "footer": {
    "privacyPolicy": "Política de Privacidad",
    "cookiePreferences": "Preferencias de cookies",
    "socialMediaNav": "Enlaces a redes sociales"
  },
  "socialNetworks": {
    "connectWith": "Conectar con {{network}}"
  },
  "accessibility": {
    "skipToMain": "Saltar al contenido principal"
  }
}
